// todo: rewrite this
export function verifyType<T>(obj: any, target: T): boolean {
  for (const prop of Object.getOwnPropertyNames(target)) {
    if (!obj.hasOwnProperty(prop)) {
      return false;
    }
  }
  return true;
}
